import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import request from '../request';
/**
 * Get the content of a file
 * @param {string} workspace
 * @param {string} path
 * @param {boolean} base64
 * @param {number} version
 * @returns {Promise<string>} a promise resolved with the file content
 */

export var getContent = function getContent(workspace, path) {
  var base64 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
  return request({
    url: '/backend/content',
    query: {
      workspace: workspace,
      path: path,
      base64: base64,
      version: version
    }
  });
};
/**
 * Add a file preserving all tags of the previous file if exists
 * @param {string} workspace
 * @param {string} path
 * @param {Blob} contentBlob
 */

export var addFile = function addFile(workspace, path, contentBlob) {
  var formData = new FormData();
  formData.append('file', contentBlob);
  return request({
    url: '/backend/content',
    method: 'POST',
    query: {
      workspace: workspace,
      filePath: path
    },
    data: formData
  });
};
export var getPreview = function getPreview(workspace, path) {
  var resourceToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'reader';
  return request({
    url: "/backend/preview?resourceToken=".concat(encodeURIComponent(resourceToken), "&workspace=").concat(encodeURIComponent(workspace), "&path=").concat(encodeURIComponent(path), "&type=").concat(type),
    contentType: 'json'
  });
};
/**
 * Upload a file to a specified folder path
 * @param {object} file
 * @param {string} workspace
 * @param {string} folderPath
 * @param {boolean} optimizeImageWeb
 * @param {number} widthHeightMaxLimit
 * @return {Promise<any>}
 */

export var uploadFile = function uploadFile(file, workspace, folderPath) {
  var optimizeImageWeb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var widthHeightMaxLimit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
  return request({
    method: 'POST',
    url: '/backend/upload',
    query: {
      workspace: workspace,
      folderPath: folderPath,
      optimizeImageWeb: optimizeImageWeb || false,
      widthHeightMaxLimit: widthHeightMaxLimit
    },
    attach: _defineProperty({}, file.name, file)
  });
};
/**
 * Upload a file to get it's content as base64 string
 * @param {object} file
 * @return {Promise<string>}
 */

export var uploadFileForBase64Content = function uploadFileForBase64Content(file) {
  var formData = new FormData();
  formData.append('file', file);
  return request({
    method: 'POST',
    url: '/backend/upload',
    data: formData
  });
};
export default {
  getContent: getContent,
  addFile: addFile,
  getPreview: getPreview,
  uploadFile: uploadFile,
  uploadFileForBase64Content: uploadFileForBase64Content
};